<template>
  <div id="breadcrumb">
    <b-breadcrumb id="breadcrumb" :items="breadItems" class="container"></b-breadcrumb>
    <!-- <nav aria-label="breadcrumb">
      <div class="container">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="https://tstar888.com/JP2TW/">
                <font-awesome-icon class="fa_icon" icon="fa-solid fa-house"></font-awesome-icon>
                首頁
              </a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">北部 (台北市、新北市、基隆、桃園、新竹、苗栗)</li>
            <li class="breadcrumb-item active" aria-current="page">台北市</li>
        </ol>
        </div>
    </nav> -->
  </div>
</template>

<script>
export default {
  props: {
    breadItems: {
      required: true
    }
  }
}
</script>

<style lang="scss">
#breadcrumb {
  // background-color: var(  --bs-gray-200);
  // padding: .5rem;
  background-color: #e9ecef;
  .breadcrumb {
    margin-bottom: 0 !important;
    & a{
      color: #6c757d;
      font-weight: 500;
    }
    & a:hover{
      text-decoration: none;
    }
  }
  .fa_icon{
    color: #FCBA4E;
  }
  .breadcrumb-item + .breadcrumb-item::before {
    float: left;
    padding-right: 0.5rem;
    color: #6c757d;
    content: ">";
  }
  .container {
    // display: inline;
    // margin-block-start: 1em;
    // margin-block-end: 1em;
    // margin-inline-start: 0px;
    // margin-inline-end: 0px;
    // padding-inline-start: 40px;
  }
}
</style>
